import { user } from 'Cloud/Application/User';
import { store } from 'reactApp/store';

const { updateUser } = require('./user.thunkActions');

export const waitForUserUpdate = () => store.dispatch(updateUser()).then(() => user.updateUserData());
